import _t from 'i18n!nls/author-peer-review';

const getLabelTranslation = (key: string) => {
  switch (key) {
    case 'graded':
      return _t('Graded');
    case 'standard':
      return _t('Practice');
    case 'phased':
      return _t('Learners can review peers only after submitting their own work.');
    case 'closed':
      return _t('Learners can review peers only after submitting their own work.');
    default:
      return '';
  }
};

// Maps the typeName to display typeName
const PeerReviewTypes = {
  GRADED: {
    typeName: 'graded',
    publishedTypeName: 'gradedPeer',
    get label() {
      return getLabelTranslation('graded');
    },
  },
  STANDARD: {
    typeName: 'standard',
    publishedTypeName: 'peer',
    get label() {
      return getLabelTranslation('standard');
    },
  },

  // Phased and Closed are analagous, except that Phased is used for session-based and Closed is used for ondemand.
  PHASED: {
    typeName: 'phased',
    publishedTypeName: 'phasedPeer',
    get label() {
      return getLabelTranslation('phased');
    },
  },
  CLOSED: {
    typeName: 'closed',
    publishedTypeName: 'closedPeer',
    get label() {
      return getLabelTranslation('closed');
    },
  },
} as const;

const exported = {
  PeerReviewTypes,
};

export default exported;
export { PeerReviewTypes };
